import { LazyDataStepDrawer } from "~/components/build/Show/components/StepDrawer/LazyDataStepDrawer";
import { EagerDataStepDrawer } from "~/components/build/Show/components/StepDrawer/EagerDataStepDrawer";

const StepDrawer = ({ stepOrJobId = "" }: { stepOrJobId?: string }) =>
  Features.ProgressiveBuildShow ? (
    <LazyDataStepDrawer />
  ) : (
    <EagerDataStepDrawer stepOrJobId={stepOrJobId} />
  );

export default StepDrawer;
